@if (showSkeleton()) {
<div class="skeleton-circle"></div>
} @else {
<button mat-icon-button (click)="toggleFilter()" cdkOverlayOrigin #trigger="cdkOverlayOrigin">
  <mat-icon svgIcon="ds-ic-filter"></mat-icon>
</button>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="containerRef() || trigger"
  [cdkConnectedOverlayOpen]="showFilter()"
  [cdkConnectedOverlayHasBackdrop]="true"
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  cdkConnectedOverlayPanelClass="attribute-filter-panel"
  [cdkConnectedOverlayPositions]="overlayPositions"
  [cdkConnectedOverlayWidth]="overlayWidth()"
  [cdkConnectedOverlayHeight]="overlayHeight()"
  (detach)="showFilter.set(false)"
  (attach)="onOverlayAttached()"
>
  <div class="attribute-filter-overlay">
    <div class="attribute-filter">
      <div class="attribute-filter__header">
        <h3 class="title" i18n="@@S_ATTRIBUTE_FILTER_TITLE">Filter by attribute</h3>
        <mat-icon svgIcon="ds-ic-close" class="mat-icon-size-xs" (click)="showFilter.set(false)"></mat-icon>
      </div>
      <mat-divider></mat-divider>
      <fm-attribute-tree-node
        [treeNodes]="treeNodes()"
        [loading]="loading()"
        [error]="error()"
        (selectionChange)="onFilterApply($event)"
        (refreshClicked)="refreshClicked.emit()"
      ></fm-attribute-tree-node>
    </div>
  </div>
</ng-template>
}
